import { render, staticRenderFns } from "./caseTypeChat.vue?vue&type=template&id=03bf2f7b&"
import script from "./caseTypeChat.vue?vue&type=script&lang=js&"
export * from "./caseTypeChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports